/** Image processing utilities */
import { EventBus } from '@/event-bus';
// eslint-disable-next-line
import api from '@/_api';
import { REMOVEBG_API } from '@/config';

const imageProcessingService = {
  removeBackground(imageSrc) {
    return api.post(REMOVEBG_API, imageSrc).then((response) => response.data.clean);
  },
  uploadToS3(srcUrl, product = null) {
    const kwargs = {
      url: srcUrl,
    };
    if (product) kwargs.product = product;
    return api.post('/upload_media_to_s3', kwargs).then((response) => {
      console.log('Image uploaded to ', srcUrl);
      return response.data.upload_url;
    }).catch((error) => {
      console.error('Something went wrong!', error);
      EventBus.$emit('toast-error', 'Failed to upload image. Please retry in a few moments');
    });
  },
};

export default imageProcessingService;
